// extracted by mini-css-extract-plugin
module.exports = {"Arrows":"Arrows_Arrows__2z25B","right":"Arrows_right__1dH48","left":"Arrows_left__3YFVH"};